import { gql } from "@apollo/client";

export const clients = gql`
  query ($where: JSON) {
    clients(where: $where) {
      user {
        id
        email
      }
      id
      name
      surname
      phone
      address {
        street
        city
        zip
        country
      }
      subscription {
        id
        valid_till
      }
      subs_trial_till
      subscription_till
      subscription_renew
      card_no
      orders {
        id
        ip
        status
        order_items {
          entity_id
          entity_type
        }
      }
      products {
        entity_id
        entity
      }
      profile {
        private
        id
        verified {
          verified
        }
        contract_signed_at
        slug
        nickname
        label
        description
        experience {
          level
          description
        }
        difficulty
        practice_focuses {
          id
          title
        }
        practice_styles {
          id
          title
        }
        contact {
          type
          value
        }
        address {
          place
          street
          city
          zip
          country
        }
        sites {
          website
          facebook
          instagram
        }
        rate {
          id
          label
          value
          unit
          currency
        }
        motive {
          image {
            url
            alternativeText
          }
          width
          height
          align
          object_fit
          apply_mobile
          background_color
          background_pattern
        }
        thumbnail {
          url
        }
        gallery {
          url
        }
      }
      is_admin
    }
  }
`;
